import { get } from 'axios'

const host = process.env.VUE_APP_CCAPI

function getBanks (token_auth) {
    
    const resource = `/fas/get_all_banks`
    const API_URL = `${host}${resource}`
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
    }
    
    return get(API_URL, { params, config })
}
    
export {
  getBanks
}